import ReplyApi from '@/api/reply'
import { cloneDeep } from 'lodash'

const defaultForm = {
  stop_at: '',
  comment_enabled: true,
  reply_type: 'generic',
  message: '',
  buttons: [],
  accounts: [],
  cards: [],
  allow_comment: true,
  comment_template_id: null,
  name: '',
  message_enabled: true,
  message_type: 'text',
  schedule: {
    type: 'stop',
    message: null,
  },
  post: {},
  comment: [''],
  comment_number: 1,
  include_url: 0,
  enable_old: true,
  enable_multiple: true,
  ai_enabled: false,
  ai_post_description: '',
  ai_limit: 100,
}
export default {
  namespaced: true,
  state: {
    templates: [],
    templatesFetched: false,
    form: { ...defaultForm },
    change: false,
    products: [],
    webview_forms: [],
    postbacks: [],
    comment_templates: [],
    dependencies_fetched: false,
    tabTypeIndex: 0,
  },
  getters: {
    templates: (state: any) => state.templates,
    accounts: (state: any) => state.accounts,
    form: (state: any) => state.form,
    change: (state: any) => state.change,
    products: (state: any) => state.products,
    forms: (state: any) => state.forms,
    postbacks: (state: any) => state.postbacks,
    comment_templates: (state: any) => state.comment_templates,
    webview_forms: (state: any) => state.webview_forms,
    tabTypeIndex: (state: any) => state.tabTypeIndex,
    dependencies_fetched: (state: any) => state.dependencies_fetched,
  },
  mutations: {
    SET_FORM(state: any, payload: any) {
      state.form = { ...state.form, ...cloneDeep(payload) }
    },
    SET_TAB_INDEX(state: any, index: number) {
      state.tabTypeIndex = index
    },
    SET_POST(state: any, post: any) {
      state.post = post
    },
    SET_TEMPLATES(state: any, templates: any) {
      state.templates = templates
    },
    SET_DEFAULT_FORM(state: any) {
      state.form = { ...defaultForm }
    },
    SET_TEMPLATES_FETCHED(state: any, payload: any) {
      state.templatesFetched = payload
    },
    SET_DEPENDENCIES(state: any, payload: any) {
      state.comment_templates = payload.comments
      state.webview_forms = payload.forms
      state.templates = payload.templates
      state.accounts = payload?.accounts ?? []
      state.dependencies_fetched = true
    },
    SET_DEPENDENCIES_FETCHED(state: any, payload: boolean) {
      state.dependencies_fetched = payload
    },
  },
  actions: {
    async GET_TEMPLATES(context: any) {
      if (context.state.templatesFetched) return
      await ReplyApi.templatesList().then((data: any) => {
        context.commit('SET_TEMPLATES', data.templates)
        context.commit('SET_TEMPLATES_FETCHED', true)
      }).catch(() => {
      })
    },
    async GET_DEPENDENCIES(context: any) {
      if (context.state.dependencies_fetched) return
      await ReplyApi.dependencies().then((data: any) => {
        context.commit('SET_DEPENDENCIES', data)
      }).catch(e => {
        throw e
      })
    },
  },
}
